"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertExpenseCategoryToNum = void 0;
const expense_category_enums_1 = require("./expense-category.enums");
/**
 * Use this function to convert between back-end ExpenseCategory values and string
 * generated through graphql layer
 * @returns -1 if undefined, otherwise the number value of the enum
 */
const convertExpenseCategoryToNum = (expenseCategory) => {
    if (!expenseCategory) {
        return -1;
    }
    return expense_category_enums_1.ExpenseCategory[expenseCategory];
};
exports.convertExpenseCategoryToNum = convertExpenseCategoryToNum;
